import { requestAdminRefresh } from './adminAuthApi';

// 사용자 세션(garam-user-auth)과 섞이지 않도록 관리자는 별도 키에 저장한다.
const ADMIN_AUTH_KEY = 'garam-admin-auth';
let refreshRequest;

// 저장할 수 있는 형태의 세션인지 확인한다.
function isValidSession(data) {
    return typeof data?.accessToken === 'string' && data.accessToken.trim() !== '';
}

// 토큰의 exp만 보고 만료 여부를 판단한다. 서명 검증은 서버가 한다.
function isTokenExpired(token) {
    try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const { exp } = JSON.parse(atob(base64));
        return typeof exp !== 'number' || exp * 1000 <= Date.now();
    } catch {
        return true;
    }
}

// 저장된 관리자 세션을 읽고, 없거나 만료됐으면 null을 돌려준다.
export function readAdminSession() {
    try {
        const data = JSON.parse(sessionStorage.getItem(ADMIN_AUTH_KEY));
        return isValidSession(data) && !isTokenExpired(data.accessToken) ? data : null;
    } catch {
        return null;
    }
}

// 로그인·재발급 응답을 관리자 세션으로 저장한다. 응답에 user가 없으면 기존 값을 유지한다.
export function saveAdminSession(data) {
    if (!isValidSession(data)) throw new Error('로그인 응답을 확인하지 못했습니다.');
    let previousUser = null;
    try {
        previousUser = JSON.parse(sessionStorage.getItem(ADMIN_AUTH_KEY))?.user ?? null;
    } catch {
        previousUser = null;
    }
    const session = { accessToken: data.accessToken, user: data.user ?? previousUser };
    sessionStorage.setItem(ADMIN_AUTH_KEY, JSON.stringify(session));
    return session;
}

// 세션이 지워지면 알릴 이벤트 이름. RequireAdmin이 듣고 로그인 화면으로 보낸다.
export const ADMIN_AUTH_CHANGE_EVENT = 'garam-admin-auth-change';

// 관리자 세션을 지우고 변경을 알린다.
export function clearAdminSession() {
    sessionStorage.removeItem(ADMIN_AUTH_KEY);
    window.dispatchEvent(new Event(ADMIN_AUTH_CHANGE_EVENT));
}

// 토큰이 남아 있어도 refresh 쿠키로 새로 발급받는다. 실패하면 세션을 지우고 null.
export function refreshAdminSession() {
    // StrictMode의 이중 실행이나 동시 요청에서도 refresh를 한 번만 보낸다.
    if (!refreshRequest) {
        refreshRequest = requestAdminRefresh()
            .then(saveAdminSession)
            .catch(() => {
                clearAdminSession();
                return null;
            })
            .finally(() => { refreshRequest = undefined; });
    }
    return refreshRequest;
}

// 유효한 세션을 돌려주고, 없거나 만료됐으면 refresh 쿠키로 재발급한다. 실패하면 null.
export async function ensureAdminSession() {
    return readAdminSession() || refreshAdminSession();
}
